import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/api";
import { LogoMark } from "@/context/BrandingContext";
import { Loader2, MailCheck } from "lucide-react";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setError(""); setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email: email.trim() });
      setDone(true);
    } catch (err) { setError(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-900 p-6">
      <div className="w-full max-w-sm rounded-2xl bg-white p-8 shadow-xl" data-testid="forgot-page">
        <div className="mb-6 flex items-center gap-3"><LogoMark size={44} rounded="rounded-xl" /><div><div className="font-display text-lg font-bold text-slate-900">DispatchMe</div><div className="text-xs uppercase tracking-widest text-slate-400">Wachtwoord vergeten</div></div></div>
        {done ? (
          <div className="text-center" data-testid="forgot-done">
            <MailCheck className="mx-auto mb-3 h-12 w-12 text-emerald-500" />
            <h2 className="font-display text-xl font-bold text-slate-900">Controleer je e-mail</h2>
            <p className="mt-2 text-sm text-slate-500">Als dit e-mailadres bij ons bekend is, hebben we een herstel-link gestuurd. De link is 45 minuten geldig.</p>
            <button onClick={() => navigate("/login")} className="mt-5 w-full rounded-xl bg-blue-600 py-2.5 text-sm font-semibold text-white hover:bg-blue-500">Naar inloggen</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <p className="text-sm text-slate-500">Vul je e-mailadres in. We sturen je een link om een nieuw wachtwoord te kiezen.</p>
            <div>
              <label className="mb-1 block text-xs font-semibold uppercase tracking-wide text-slate-500">E-mailadres</label>
              <input data-testid="forgot-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full rounded-xl border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-blue-500" placeholder="naam@voorbeeld.nl" />
            </div>
            {error && <div data-testid="forgot-error" className="rounded-lg bg-red-50 px-3 py-2 text-sm text-red-600">{error}</div>}
            <button data-testid="forgot-submit" type="submit" disabled={loading} className="flex w-full items-center justify-center gap-2 rounded-xl bg-blue-600 py-2.5 text-sm font-semibold text-white hover:bg-blue-500 disabled:opacity-60">{loading && <Loader2 className="h-4 w-4 animate-spin" />} Herstel-link sturen</button>
            <button type="button" onClick={() => navigate("/login")} className="w-full text-center text-xs text-slate-400 hover:text-slate-600">← Terug naar inloggen</button>
          </form>
        )}
      </div>
    </div>
  );
}
